<template>
    <v-sprite
        :id="png | slugy"
        :spritesheet="png"
        :json="json"
        :yoyo="false"
        :fps="fps"
        ref="sprite"
    ></v-sprite>
</template>
<script>
import Vue from "vue";
import VueSpriteAnimator from "vue-sprite-animator";
Vue.use(VueSpriteAnimator);

export default {
    name: "SpriteAnim",
    props: {
        json: {
            type: [String, Object],
            required: true
        },
        png: {
            type: String,
            required: true
        },
        fps: {
            type: Number,
            required: true
        }
    },
    created() {},
    methods: {
        play() {
            this.$refs.sprite.play();
        },
        stop() {
            this.$refs.sprite.stop();
        }
    }
};
</script>

<style scoped>
.zindex3 {
    position: relative;
    z-index: 3;
}
</style>
